import { PackagePrices } from 'types/join';

export const allAvailablePlans = [
  'RapNet Dealer',
  'RapNet Buyer',
  'RapNet Buyer India',
  'RapNet Buyer Pro',
  'RapNet Primary Supplier',
  'Rapaport Basic',
  'Rapaport Plus',
  'Rapaport Research Report'
];
export const allAvailableAddons = [
  'Member Addon',
  'Rapaport Magazine',
  'Rapaport Research Report add-on',
  'Instant Inventory'
];

export const priceListPlans = ['Rapaport Basic', 'Rapaport Plus', 'Rapaport Research Report'];

export const steps = ['Details', 'Verification', 'Complete Registration'];

export const getPlanColor = (plan?: string) => {
  switch (plan) {
    case 'Rapaport Plus':
    case 'Rapaport Basic': {
      return '#C10230';
    }
    case 'Rapaport Research Report': {
      return '#434343';
    }
    case 'RapNet Buyer': {
      return '#AF3D8E';
    }
    case 'RapNet Buyer India': {
      return '#F47A20';
    }
    case 'RapNet Buyer Pro':
    case 'RapNet Buyer Pro India': {
      return '#23A456';
    }
    case 'RapNet Dealer': {
      return '#009ED3';
    }
    case 'RapNet Primary Supplier': {
      return '#E4B92E';
    }
    default: {
      return '';
    }
  }
};

export const getAddonName = (addon: PackagePrices) => {
  if (addon.packageName === 'Member Addon') return `Additional User `;
  if (addon.packageName === 'Rapaport Research Report add-on') return `Rapaport Research Report`;
  else return addon.packageName;
};
export const getPlanText = (packageName: string) => {
  if (packageName === 'RapNet Buyer') return 'rapnet_buyer_text';
  if (packageName === 'RapNet Buyer India') return 'rapnet_buyer_india_text';
  if (packageName === 'RapNet Buyer Pro' || packageName === 'RapNet Buyer Pro India')
    return 'rapnet_buyer_pro_text';
  if (packageName === 'RapNet Dealer') return 'rapnet_dealer_text';
  if (packageName === 'RapNet Primary Supplier') return 'rapnet_primary_supplier_text';
  if (packageName === 'Rapaport Basic') return 'rapaport_monthly_price_list_text';
  if (packageName === 'Rapaport Plus') return 'rapaport_weekly_price_list_text';
  if (packageName === 'Rapaport Research Report') return 'rapaport_research_report_text';
};

export const getAddonText = (packageName: string) => {
  if (packageName === 'Rapaport Magazine') return 'rapaport_magazine_tooltip';
  if (packageName === 'Member Addon') return 'additional_user_tooltip';
  if (packageName === 'Instant Inventory') return 'instant_inventory_tooltip';
  if (packageName === 'Rapaport Research Report add-on')
    return 'rapaport_research_report_adoon_tooltip';
};

export const planNameToPackageId = (
  planText: string,
  companyCountry: string,
  packagePrices: PackagePrices[] | null
) => {
  const plan = planText?.toLowerCase().replaceAll(/\s/g, '');
  if (plan === 'rapnetdealer')
    return packagePrices?.filter(p => p.packageName === 'RapNet Dealer')[0]?.packageId || '';
  if (plan === 'rapnetbuyer')
    return packagePrices?.filter(p => p.packageName === 'RapNet Buyer')[0]?.packageId || '';
  if (plan === 'rapnetbuyerindia')
    return packagePrices?.filter(p => p.packageName === 'RapNet Buyer India')[0]?.packageId || '';
  if (plan === 'rapnetbuyerpro')
    return packagePrices?.filter(p => p.packageName === 'RapNet Buyer Pro')[0]?.packageId || '';
  if (plan === 'rapnetprimarysupplier')
    return (
      packagePrices?.filter(p => p.packageName === 'RapNet Primary Supplier')[0]?.packageId || ''
    );
  if (plan === 'pricesheetmonthly' || plan === 'rapaportbasic')
    return packagePrices?.filter(p => p.packageName === 'Rapaport Basic')[0]?.packageId || '';
  if (plan === 'pricesheetweekly' || plan === 'rapaportplus')
    return packagePrices?.filter(p => p.packageName === 'Rapaport Plus')[0]?.packageId || '';
  if (plan === 'rapaportresearchreport')
    return (
      packagePrices?.filter(p => p.packageName === 'Rapaport Research Report')[0]?.packageId || ''
    );
  return '';
};

export const foundValue = (array: number[], value: number) => {
  let isFound = false;
  array.forEach(el => {
    if (el === value) {
      isFound = true;
    }
  });
  return isFound;
};
